import AlephBet from "alephbet"
import {storage_adapter, lamed_adapter} from "./adapters"
import {not_logged_in} from "./helpers"
import {registered_successfully} from "./goals"
import $ from "cash-dom"
import trophy_img from "images/ab_trophy.svg"
import clipboard_img from "images/ab_clipboard.svg"
import gem_img from "images/ab_gem.svg"
import trust_seal_en from "images/application/scientifically_approved.en.webp"
import trust_seal_de from "images/application/scientifically_approved.de.webp"
import trust_seal_es from "images/application/scientifically_approved.es.webp"
import trust_seal_pt from "images/application/scientifically_approved.pt.webp"
import trust_seal_fr from "images/application/scientifically_approved.fr.webp"

export default () => {
  const trust_copy_on_header = new AlephBet.Experiment({
    name: "202405 Trust copy on header",
    tracking_adapter: lamed_adapter,
    storage_adapter: storage_adapter,
    trigger: () => (not_logged_in()),
    variants: {
      "1-Original": {
        activate: () => {
        }
      },
      "2-Trust-copy": {
        activate: (experiment) => {
          if (!experiment.options.trigger()) return
          if ($(".l-hero--nav .tagline").length) return

          const localizedCopy = {
            en: {
              tagline:
                "<strong>#1 platform</strong> for <br/> learning anatomy",
              item_1: {
                primary: "The #1 platform to learn anatomy",
                secondary: "6,004,735 users worldwide"
              },
              item_2: {
                primary: "Exam success since 2011",
                secondary: "Serving healthcare students globally"
              },
              item_3: {
                primary: "Reviewed by medical experts",
                secondary:
                  "2,907 articles, quizzes and videos"
              }
            },
            es: {
              tagline:
                "La <strong>plataforma nº 1</strong> para <br/>" +
                "aprender anatomía",
              item_1: {
                primary:
                  "La plataforma nº 1 para aprender anatomía",
                secondary:
                  "6.004.735 usuarios en todo el mundo"
              },
              item_2: {
                primary: "Éxito en los exámenes desde 2011",
                secondary:
                  "Ayudando a estudiantes del área de salud"
              },
              item_3: {
                primary: "Revisado por especialistas médicos",
                secondary:
                  "1.435 artículos, cuestionarios y videos"
              }
            },
            pt: {
              tagline:
                "A <strong>plataforma nº 1</strong> para <br/>" +
                "aprender anatomia",
              item_1: {
                primary:
                  "A plataforma nº 1 para aprender anatomia",
                secondary:
                  "6.004.735 usuários em todo o mundo"
              },
              item_2: {
                primary: "Sucesso em provas desde 2011",
                secondary:
                  "Ajudando estudantes da área da saúde"
              },
              item_3: {
                primary: "Revisado por especialistas médicos",
                secondary:
                  "1.410 artigos, testes e vídeos"
              }
            },
            de: {
              tagline:
                "<strong>Nr. 1 Plattform</strong> zum <br/>" +
                "Lernen der Anatomie",
              item_1: {
                primary:
                  "Die führende Plattform für Anatomie",
                secondary: "6.004.735 Nutzer weltweit"
              },
              item_2: {
                primary: "Erfolg bei Prüfungen seit 2011",
                secondary:
                  "Hilft Studierenden im Gesundheitswesen"
              },
              item_3: {
                primary:
                  "Von medizinischen Fachleuten geprüft",
                secondary:
                  "2.089 Artikel, Quizze und Videos"
              }
            },
            fr: {
              tagline:
                "La <strong>Plateforme n°1</strong> pour <br/> " +
                "apprendre l’anatomie",
              item_1: {
                primary:
                  "La platforme d’anatomie n°1",
                secondary:
                  "6 004 735 utilisateurs dans le monde"
              },
              item_2: {
                primary: "Réussite aux examens depuis 2011",
                secondary:
                  "Soutient les étudiants en santé"
              },
              item_3: {
                primary: "Révisé par des experts médicaux",
                secondary: "812 articles, quiz et vidéos"
              }
            }
          }

          const trustSeals = {
            en: trust_seal_en,
            de: trust_seal_de,
            es: trust_seal_es,
            pt: trust_seal_pt,
            fr: trust_seal_fr
          }

          const locale = window.gon.locale
          const copy = localizedCopy[locale]
          const sealSrc = trustSeals[locale]

          const taglineHTML =
            "<div class='tagline'>" +
              `<div class="text">${copy.tagline}</div>` +
              `<img src="${sealSrc}" class="seal"` +
              "width='50' height='50'>" +
            "</div>"

          $("body").addClass("ab-test__trust-copy-on-header")

          if ($(".l-topbar").length) {
            if (!$(".l-hero--nav").length) {
              $(
                "<div class='l-hero--nav'>" +
                  "<div class='l-container'>" +
                    "<div class='l-navigation'></div>" +
                  "</div>" +
                "</div>"
              ).insertAfter(".l-topbar")
            }

            const $container = $(
              ".l-hero--nav .l-container .l-navigation"
            )

            if ($container.length) {
              $container.prepend(taglineHTML)

              const subsection =
                "<div class='l-hero--subsection' " +
                  "data-controller='headroom' " +
                  "data-slideout-target='topbarMobile'>" +
                "<div class='l-container'>" +
                  "<div class='trust-items'>" +
                    "<div class='item'>" +
                      `<img src="${trophy_img}" width="24" ` +
                      "height='24'>" +
                      "<div class='text'>" +
                        "<div class='primary'>" +
                          `${copy.item_1.primary}</div>` +
                        "<div class='secondary'>" +
                          `${copy.item_1.secondary}</div>` +
                      "</div>" +
                    "</div>" +
                    "<div class='item'>" +
                      `<img src="${clipboard_img}" width="24" ` +
                      "height='24'>" +
                      "<div class='text'>" +
                        "<div class='primary'>" +
                          `${copy.item_2.primary}</div>` +
                        "<div class='secondary'>" +
                          `${copy.item_2.secondary}</div>` +
                      "</div>" +
                    "</div>" +
                    "<div class='item'>" +
                      `<img src="${gem_img}" width="24" ` +
                      "height='24'>" +
                      "<div class='text'>" +
                        "<div class='primary'>" +
                          `${copy.item_3.primary}</div>` +
                        "<div class='secondary'>" +
                          `${copy.item_3.secondary}</div>` +
                      "</div>" +
                    "</div>" +
                  "</div>" +
                "</div>" +
                "</div>"
              $(".l-hero--nav").after(subsection)
            }
          }

          const $mobileNav = $(".l-topbar-mobile")
          const $logo = $mobileNav.find(".mobile-logo")

          if ($logo.length && !$mobileNav.find(".tagline").length) {
            $logo.after(taglineHTML)
          }

          let trustSliderInit = false

          function initTrustSlider() {
            const $items = $(".trust-items .item")
            let current  = 0

            $items.removeClass("is-visible")
                  .eq(current).addClass("is-visible")

            setInterval(() => {
              const $old     = $items.eq(current)
              current        = (current + 1) % $items.length
              const $new     = $items.eq(current)

              $old.removeClass("is-visible")
              $new.addClass("is-visible")
            }, 5000)

            trustSliderInit = true
          }

          if (window.innerWidth < 1024 && !trustSliderInit) {
            initTrustSlider()
          }

          $(window).on("resize", () => {
            if (window.innerWidth < 1024 && !trustSliderInit) {
              initTrustSlider()
            }
          })
        }
      }
    }
  })

  trust_copy_on_header.add_goals([
    registered_successfully
  ])
}
